import { FontAwesomeIconProps } from "@fortawesome/react-fontawesome"
import { Box, ListItemText, Typography } from "@mui/material"
import { CircleIcon } from "components/icons/CircleIcon"

export interface CContent {
  icon: FontAwesomeIconProps["icon"]
  size: FontAwesomeIconProps["size"]
  color: "primary" | "secondary" | "error" | "warning" | "info" | "success"
  subtitle: string
  title: string
  footer: any
  infoText: any
  backgroundColor: string
}

const SidebarHeader = (props: CContent) => {
  const { icon, size, color, subtitle, title, footer, infoText, backgroundColor } = props
  return (
    <Box pb={infoText && 2} sx={{ borderBottom: "1px solid #e0e0e0" }}>
      <Box pb={3} display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <CircleIcon color={color} backgroundColor={backgroundColor} icon={icon} size={size} />
          <Box ml={2} flexDirection="column" justifyContent="center">
            <ListItemText
              primary={
                <Typography color="textPrimary" variant="h2">
                  {title}
                </Typography>
              }
              secondary={
                <Typography color="textSecondary" variant="bodySmall">
                  {subtitle}
                </Typography>
              }
            />
          </Box>
        </Box>
        <Box>{footer && footer}</Box>
      </Box>
      {infoText && infoText}
    </Box>
  )
}

export default SidebarHeader
